import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';

import MoveIcon from '@common/images/move.svg';

const ENTER_KEY = 13;
/**
 * MoveOption :
 * - MoveOption for RectangleNode
 */
export function MoveOption(props) {
  const onClick = (event) => props.onSelect(event);

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.onSelect(event);

  return props.onSelect ? (
    <div
      tabIndex={props.tabIndex}
      onKeyDown={onKeyDown}
      onClick={onClick}
      className={props.className}>
      <Image src={MoveIcon} alt='move node' />
    </div>
  ) : null;
}

MoveOption.propTypes = {
  /**
   * Callback for onClick/onKeyDown event
   */
  onSelect: PropTypes.func,
  /**
   * tabIndex
   */
  tabIndex: PropTypes.number,
};

MoveOption.defaultProps = {
  onSelect: undefined,
};
